<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { InitializationState } from './store'
import $store from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { useApi } from './Api'
import { findFirstOrganisationId } from './components/login/login'

const $router = useRouter()
const $route = useRoute()
const $api = useApi()

const refreshedLogin = ref<boolean>(false)

onMounted(async () => {
  const loggedIn = await refreshLogin()
  $store.commit('setInitializationState', InitializationState.Initialized)
  refreshedLogin.value = true
  if (loggedIn) {
    if ($route.name === 'Login') {
      await $router.push('/dashboard')
    }
  }
})

async function refreshLogin(): Promise<boolean> {
  await $router.isReady()
  if ($route.path === '/password-reset') {
    return false
  }
  try {
    $store.commit('setInitializationState', InitializationState.Initializing)
    const response = await $api.reAuthenticate()
    $api.user = response.user
    $api.accessToken = response.accessToken
    if (response.user.organisationId) {
      $store.commit('setOrganisationId', response.user.organisationId)
    } else {
      const organisationId = await findFirstOrganisationId($api)
      $store.commit('setOrganisationId', organisationId)
    }
    return true
  } catch (error) {
    console.error(error)
    await $router.push('/')
    return false
  }
}
</script>
<template>
  <v-app style="background-color: #fff">
    <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component" v-if="refreshedLogin" />
      </transition>
    </router-view>
  </v-app>
</template>

<style>
html {
  overflow-y: hidden !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#appTitle > div {
  width: 280px !important;
}
.toasted {
  font-family: Roboto;
}
.activeMenu {
  background-color: #02576f1b;
}
.v-toast,
.v-toast--bottom {
  font-family: 'Roboto';
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.blob {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
  animation: pulse-white 2s infinite;
}

.primaryBlob {
  box-shadow: 0 0 0 0 rgba(2, 87, 111, 1);
  animation: pulse-primary 2s infinite;
}

@keyframes pulse-white {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

@keyframes pulse-primary {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(2, 87, 111, 0.25);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(2, 87, 111, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(2, 87, 111, 0);
  }
}

.v-btn {
  font-weight: 400 !important;
}

.v-card__actions {
  border-top: 1px solid rgba(160, 160, 160, 0.2);
}

.toasty {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400 !important;
}

.fullScreenMenu {
  display: flex !important;
  flex-direction: column;
}
</style>
